export const linkToEpocusHome = () => "/epocus/home";
export const linkToEpocusReview = () => "/epocus/review";
export const linkToEpocusReviewEncounter = (encounterId: string) =>
  `/epocus/review/encounter/${encounterId}`;
export const linkToEpocusReviewPanel = (examId: string) =>
  `/epocus/review/${examId}`;
export const linkToEpocusMe = () => "/epocus/me";
export const linkToEpocusProgram = () => "/epocus/program";
export const linkToEpocusPerformer = (performerId: string) =>
  `/epocus/program/performers/${performerId}`;
export const linkToEpocusQaWorkload = () => "/epocus/program/qa-workload";
export const linkToEpocusCredentialing = () => "/epocus/program/credentialing";
export const linkToEpocusBilling = () => "/epocus/billing";
export const linkToEpocusBillingReport = (examId: string) =>
  `/epocus/billing/reports/${examId}`;
export const linkToEpocusReferralsInbox = () => "/epocus/referrals/inbox";
export const linkToEpocusOnboarding = () => "/epocus/onboarding";
export const linkToEpocusSettings = () => "/epocus/settings";
export const linkToEpocusManageUsers = () => "/epocus/settings/users";
export const linkToEpocusProgramConfig = () => "/epocus/settings/program";
export const linkToEpocusAuditTrail = () => "/epocus/settings/audit";
export const linkToEpocusAddUser = () => "/epocus/settings/users/new";
export const linkToEpocusEditUser = (userId: string) =>
  `/epocus/settings/users/${userId}/edit`;
export const linkToEpocusReferralDetail = (referralId: string) =>
  `/epocus/referrals/${referralId}`;

export const linkToEpocusNewEncounter = () => "/epocus/encounters/new";
export const linkToEpocusEncounter = (encounterId: string) =>
  `/epocus/encounters/${encounterId}`;
export const linkToEpocusExam = (encounterId: string, examId: string) =>
  `/epocus/encounters/${encounterId}/exams/${examId}`;
export const linkToEpocusAddExam = (encounterId: string) =>
  `/epocus/encounters/${encounterId}/exams/new`;

export const getCurrentTab = (pathname: string): string => {
  if (pathname.startsWith(linkToEpocusReview())) return linkToEpocusReview();
  // Match any referrals sub-path (inbox, detail) so the nav item stays highlighted
  if (pathname.startsWith("/epocus/referrals"))
    return linkToEpocusReferralsInbox();
  if (pathname.startsWith(linkToEpocusBilling())) return linkToEpocusBilling();
  if (pathname.startsWith(linkToEpocusMe())) return linkToEpocusMe();
  if (pathname.startsWith(linkToEpocusQaWorkload()))
    return linkToEpocusQaWorkload();
  if (pathname.startsWith(linkToEpocusCredentialing()))
    return linkToEpocusCredentialing();
  if (pathname.startsWith(linkToEpocusProgram())) return linkToEpocusProgram();
  if (pathname.startsWith(linkToEpocusSettings()))
    return linkToEpocusSettings();
  return linkToEpocusHome();
};
